import { server } from '../server';
/**
 * @param tokenAddress use bonding token address for undergrad, agent token address for graduated, case-insensitive
 */
export const getHolders = async (chainLayer, tokenAddress) => {
    const response = await server.get({
        endpoint: 'holders',
        queryParams: new URLSearchParams({
            token: tokenAddress,
        }),
        chainLayer,
    });
    if (!response.ok) {
        throw new Error(`Error fetching holders with bonding token address ${tokenAddress}: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};
